import { ComponentProps, FC, useMemo, useState } from 'react'
import { PhoneIcon, TelegramIcon, VKIcon, WhatsAppIcon } from '@/utils/icons'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { useCRMContext } from '../../CRMContext'
import amclasses from '@pages/Admin/CRM/styles/ammodal.module.css'
import classes from './index.module.css'
import { Automation } from '@/api/types/crm.types'
import { Modal } from 'antd'
import { wazzupIntegrationApi } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { selectProfile } from '@store/profile.reducer'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import { CRMIntegrationType, getCrmIntegrations } from './integrations'
import { getDisabledIntegrationsForCRMPhoneField } from '@pages/Admin/CRMSettings/tabs/ProfilePage/components/ProfileFieldItem/utils'

interface PhoneIntegrationButtonsProps {
  tooltipProps?: ComponentProps<typeof TooltipWrapper>
  leadId: number
  fieldId: number
  fieldSettings: unknown
}

const PhoneIntegrationButtons: FC<PhoneIntegrationButtonsProps> = ({
  tooltipProps,
  leadId,
  fieldId,
  fieldSettings,
}) => {
  const addAlert = useAddAlert()
  const profile = useSelector(selectProfile)
  const { wazzupIntegrationsData } = useCRMContext()
  const [stateModal, setStateModal] = useState<{
    open: boolean
    type?: CRMIntegrationType
    iframeUrl?: string
  }>({ open: false })

  const integrations = getCrmIntegrations(wazzupIntegrationsData)

  const disabledIntegrations = useMemo(
    () => getDisabledIntegrationsForCRMPhoneField(fieldSettings),
    [fieldSettings],
  )

  return (
    <div className={classes.list}
    
    >
      {integrations
        .filter(i => !i.is_disabled_for_lead)
        .filter((i) => !i.is_active ? true : !disabledIntegrations.includes(i.key))
        .map(({ key, icon: Icon, is_active, color }) => (
          <TooltipWrapper
            key={key}
            title={!is_active ? 'Интеграция ещё не подключена' : null}
            {...tooltipProps}
          >
            <div
              className={classes.linkWrapper}
              style={{ cursor: is_active ? 'pointer' : 'default' }}
              onClick={() => {
                if (!is_active) return

                // FIXME: потом исправить
                if (key === 'phone') return

                wazzupIntegrationApi
                  .generateChatIframe({
                    account_id: wazzupIntegrationsData?.account?.id,
                    chatType: key,
                    // TODO: передавать из контекста лида ID поля с телефоном,
                    //  по умолчанию телефон лида crm_lead_field_id = 4
                    // user_id текущий пользователь (МОП, РОП, Администратор)
                    phone_field_id: fieldId,
                    lead_id: leadId,
                    user_id: profile.id,
                  })
                  .then((res) => {
                    if (res?.data?.data?.iframe_url) {
                      setStateModal({
                        open: true,
                        type: key,
                        iframeUrl: res.data.data.iframe_url,
                      })
                    }
                  })
                  .catch(() =>
                    addAlert({
                      title: 'Ошибка',
                      text: 'Не удалось загрузить интеграцию',
                      type: 'error',
                    }),
                  )
              }}
            >
              <Icon style={{ fill: is_active ? color : '#DADADA' }} />
            </div>
          </TooltipWrapper>
        ))}

      <Modal
        open={stateModal.open}
        onOk={() => setStateModal({ open: false })}
        onCancel={() => setStateModal({ open: false })}
        footer={null}
        title={null}
        centered
        maskClosable
        className={cn(amclasses.modal, classes.iframeModal)}
      >
        <iframe src={stateModal.iframeUrl} className={classes.iframe} />
      </Modal>
    </div>
  )
}

export default PhoneIntegrationButtons
